<template>
    <div class="c-account__wrapper">
        <div class="o-grid c-account">
            <div class="o-grid-4 c-account__left">
                <div class="c-account__nav">
                    <h3 class="c-account__title">
                        {{ _t("Menu") }}
                    </h3>
                    <ul class="c-account__nav__list">
                        <li class="c-account__nav__item">
                            <button class="c-account__nav__link" @click="link('#historique')">
                                <svg aria-hidden="true" focusable="false" class="o-ico ">
                                    <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=cfe82883f6882d10e6#refresh"></use>
                                </svg>
                                <span>{{ _t("Historique") }}</span>
                            </button>
                        </li>
                        <li class="c-account__nav__item">
                            <button class="c-account__nav__link" @click="link('#configuration')">
                                <svg aria-hidden="true" focusable="false" class="o-ico">
                                    <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=cfe82883f6882d10e6#settings-2"></use>
                                </svg>
                                <span>{{ _t("Configuration") }}</span>
                            </button>
                        </li>
                        <li class="c-account__nav__item">
                            <button class="c-account__nav__link" @click="logout">
                                <svg aria-hidden="true" focusable="false" class="o-ico">
                                    <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=cfe82883f6882d10e6#logout"></use>
                                </svg>
                                <span>{{ _t("Se déconnecter") }}</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="o-grid-8 c-account__right">
                <div class="c-account__right__item">
                    <DashboardHome :currentUser="user"/>
                    <DashboardConfig />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import DashboardHome from './Dashboard/DashboardHome.vue'
import DashboardConfig from './Dashboard/DashboardConfig.vue'

export default {
    name: 'CustomerDashboard',
    data () {
        return {
            user: {},
            orders: [],
            activeTab: window.ajax_var.pages.dashboard,
            pages: window.ajax_var.pages,
        }
    },
    components: {
        DashboardHome,
        DashboardConfig
    },
    methods: {
        logout(){
            let params = {
                _wpnonce: window.ajax_var.nonce
            }
            axios.get('/wp-json/stereostore/v1/logout', {params})
                .then(response => {
                    response
                    location.href = this.pages.login
                })
                .catch(error => {
                    console.log(error)
                })
        },
        link(link){
            this.activeTab = link
            //add # to link with $router.push
            if(!link.includes('#')) {
                location.href = link
            } else {
                let offset = document.documentElement.dataset.scrollDefaultOffset? document.documentElement.dataset.scrollDefaultOffset:0;

                window.locomotiveScroll.scrollTo(link, { offset: parseInt(offset) })
                //this.$router.push(link)
            }
            //location.href = link
        },
        getUser() {
            let params = {
                _wpnonce: window.ajax_var.nonce
            }
            axios.get('/wp-json/stereostore/v1/checklogin', { params })
                .then(response => {
                    if (response.data.success == false) {
                        location.href = this.pages.login
                    }
                    this.user = response.data.data
                })
                .catch(error => {
                    console.log(error)
                })
        },
    },
    mounted(){
        this.getUser()
    }
}
</script>